/* eslint-disable max-lines-per-function */
export const scrollToTop = (anchorName = "#vue-cart") => {
  const anchor = document.querySelector(anchorName);
  const offsetTop = 20; // Add some extra top padding from the top of the page;
  const top = anchor.getBoundingClientRect().top + window.scrollY - offsetTop;
  window.scrollTo({ top, behavior: "smooth" });
};

/**
 * Function which compare two objects.
 * If these are different, scroll to the top of the page.
 * @param {Array.Object<*>} currentNotifications - cartConfig.notifications
 * @param {Array.Object<*>} newNotifications  - response.notifications
 * @returns {string}
 */
const scrollToAlerts = (currentNotifications, newNotifications = []) => {
  /** If we got null or some unexpected params, do nothing */
  if (!Array.isArray(currentNotifications) || !Array.isArray(newNotifications)) {
    return "incorrect function params";
  }

  /** If we got zero alerts => it's mean is nothing to show and scroll */
  if (newNotifications.length === 0) {
    return "zero notifications";
  }

  /**
   * If we got some alerts and their count does not equal current alters,
   * make sense to scroll to new alerts
   */
  if (currentNotifications.length !== newNotifications.length) {
    scrollToTop();
    return "not equal notifications";
  }

  /**
   * Count alerts can be equal, but quality doesn't.
   * Make sense to match new alerts with current alerts.
   * If we didn't find in current notifications some new notification so then scroll to alerts.
   */
  for (let i = 0; i < newNotifications.length; i += 1) {
    const newNotification = newNotifications[i];
    const foundNotification = currentNotifications.find(
      currentNotification => JSON.stringify(currentNotification) === JSON.stringify(newNotification)
    );
    if (!foundNotification) {
      scrollToTop();
      return "different alerts";
    }
  }

  return "equal notifications";
};

export default scrollToAlerts;
